var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.colors),function(_color,i){return _c('v-col',{key:i,attrs:{"cols":"2"}},[_c('color-picker',{staticClass:"tw-cursor-pointer",attrs:{"color":_color,"active":_color === _vm.color},on:{"click":function($event){return _vm.$emit('input', $event)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }